import { Button, Card, CardBody, Col, Row, Table } from "reactstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_ALL_ADDITIONAL_INFO_BY_DEPT_ID,
  GET_ALL_KPI_BY_DEPARTMENT_ID,
} from "../../../../GraphQL/Queries";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { decryption } from "@/containers/HelperFunctions";
import TabPlusIcon from "mdi-react/TabPlusIcon";
import Swal from "sweetalert2";
import { DELETE_DEPARTMENT_KPI } from "@/GraphQL/Mutation";
import { Pagination } from "@mui/material";
import Loader from "@/containers/Account/Profile/components/Loader";
import BreadCrumb from "@/shared/components/BreadCrumb/BreadCrumb";
import CreateEmployeeKpiModal from "../Department/CreateEmployeeKpiModal";
import imageUrl from "@/utils/api/imageUrl";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";

const DeptMemberTable = () => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 10;
  const deptID = history.location.state?.deptID;
  const deptName = history.location.state?.deptName;
  const DeptData = history.location.state?.data;
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions"))
  );
  const [page, setPage] = useState(1);
  const size = 10;
  const {
    data: kpiData,
    refetch: refetchKpi,
    loading,
  } = useQuery(GET_ALL_KPI_BY_DEPARTMENT_ID, {
    variables: {
      dept_id: Number(deptID),
      page,
      size,
    },
    skip: !Number(deptID),
  });

  const {
    data: memberData,
    loading: memberLoading,
    refetch: refetchMembers,
  } = useQuery(GET_ALL_ADDITIONAL_INFO_BY_DEPT_ID, {
    variables: {
      dept_id: deptID,
      page: currentPage,
      size: limit,
    },
  });

  const members = memberData?.getAllAdditionalInfoByDeptId?.data || [];
  const pageInfo =
    memberData?.getAllAdditionalInfoByDeptId?.paginatorInfo || {};

  const handleChange = (e, p) => {
    setCurrentPage(p);
    // sessionStorage.setItem("currentPage", p);
    // updateURLParams({ page: p });
    refetchMembers({
      page: p,
    });
  };
  const handleChangeKpi = (e, p) => {
    setPage(p);
    refetchKpi({
      page: p,
    });
  };

  const maleCount = members.filter(
    (item) => item?.user?.gender === "Male"
  ).length;
  const femaleCount = members.filter(
    (item) => item?.user?.gender === "Female"
  ).length;
  const totalMembers = members.length;
  const maleRatio = totalMembers
    ? ((maleCount / totalMembers) * 100).toFixed(2) + "%"
    : "0%";
  const femaleRatio = totalMembers
    ? ((femaleCount / totalMembers) * 100).toFixed(2) + "%"
    : "0%";

  const [deleteDepartmentkpi] = useMutation(DELETE_DEPARTMENT_KPI);
  const [kpiModalOpen, setKpiModalOpen] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedDeptId, setSelectedDeptId] = useState(null);
  const deleteHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the KPI.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const { data } = await deleteDepartmentkpi({ variables: { id } });
        if (data?.deleteDepartmentkpi?.status === "Success") {
          toast.success("KPI deleted successfully");
          refetchKpi?.();
        } else {
          toast.error(`${data?.deleteDepartmentkpi?.message}`);
        }
      } catch (err) {
        toast.error("Error deleting KPI");
        console.error(err);
      }
    }
  };

  useEffect(() => {
    if (deptID) {
      refetchMembers({ dept_id: deptID, page: currentPage, limit });
    }
  }, [currentPage, deptID]);
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Department",
      link: "/department/list",
    },
    {
      name: "Member List",
    },
  ];

  return (
    <CardBody>
      <Row>
        <Col>
          <BreadCrumb breadCrumbData={breadCrumbData} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={12}>
                  <strong>Department Name: </strong>
                  {deptName}
                </Col>
                <Col md={12}>
                  <strong>Head Of Department:</strong> {DeptData?.user?.name}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={4}>
                  <strong>Total Members:</strong> {totalMembers}
                </Col>
                <Col md={4}>
                  <strong>Male Members:</strong> {maleCount}
                </Col>
                <Col md={4}>
                  <strong>Female Members:</strong> {femaleCount}
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <strong>Male Ratio:</strong> {maleRatio}
                </Col>
                <Col md={6}>
                  <strong>Female Ratio:</strong> {femaleRatio}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <strong>Description: </strong>
                  <span>{DeptData?.description}</span>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="d-flex align-items-center">
          <h3 className="page-title mb-0">Member List</h3>
        </Col>
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              {/* <th>RFID</th> */}
              <th>Designation</th>
              <th>Email</th>
              <th>Phone</th>
              {/* <th>IP Number</th> */}
              {/* {permissions?.includes("update_department") && <th>Action</th>} */}
            </tr>
          </thead>
          <tbody>
            {memberLoading ? (
              <tr>
                <td colSpan="8" className="text-center">
                  <SubmitLoading color="black" />
                </td>
              </tr>
            ) : (
              members.map((item, index) => (
                <tr key={item?.user_id}>
                  <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {(currentPage - 1) * limit + index + 1}
                  </td>
                  <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    <img
                      // src={
                      //   item?.user?.images ||
                      //   "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                      // }
                      src={`${imageUrl}/users/${
                        item?.user?.images ||
                        "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                      }`}
                      alt="user"
                      style={{ width: 40, height: 40, borderRadius: "50%" }}
                    />
                  </td>
                  <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {" "}
                    {item?.user?.name}
                  </td>
                  {/* <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {item?.rfid}
                  </td> */}
                  <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {item?.designationInfo?.name}
                  </td>
                  <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {item?.user?.email}
                  </td>
                  <td
                    onClick={
                      permissions?.includes("update_department")
                        ? () =>
                            history.push({
                              pathname: "/profile/info",
                              state: { dept: deptID, id: item?.user_id },
                            })
                        : undefined
                    }
                    style={{
                      cursor: permissions?.includes("update_department")
                        ? "pointer"
                        : "default",
                    }}
                  >
                    {item?.user?.phone}
                  </td>
                  {/* <td>
                    {permissions?.includes("update_department") && (
                      <Tooltip title="Add KPI" arrow>
                        <button
                          className="inbox__email-btn"
                          type="button"
                          aria-label="add"
                          onClick={() => {
                            setSelectedDeptId(deptID);
                            setSelectedEmployeeId(item?.user_id);
                            setKpiModalOpen(true);
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </button>
                      </Tooltip>
                    )}
          
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {/* Pagination Controls */}

        {memberData?.getAllAdditionalInfoByDeptId?.data.length > 0 ? (
          <Pagination
            className="mt-2"
            count={pageInfo.lastPage}
            page={pageInfo?.currentPage}
            onChange={handleChange}
          />
        ) : null}
      </Row>

      {/* KPI Section */}
      {/* {permissions?.includes("delete_department") && (
        <>
          <Row className="px-3 mt-5">
            <Col md={6} className="d-flex align-items-center">
              <h3 className="page-title mb-0">KPI List</h3>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              {permissions?.includes("create_department") && (
                <Button
                  onClick={() =>
                    history.push({
                      pathname: "/department/kpi-create",
                      state: { dept: deptID },
                    })
                  }
                  color="primary"
                >
                  <TabPlusIcon className="mr-1" /> Create KPI
                </Button>
              )}
            </Col>
          </Row>

          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Key Area</th>
                <th>Description</th>
                <th>Weight</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <SubmitLoading color="black" />
                  </td>
                </tr>
              ) : kpiData?.getAllKpiByDepartmentId?.data?.length ? (
                kpiData.getAllKpiByDepartmentId?.data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item?.key_area}</td>
                    <td
                      dangerouslySetInnerHTML={{ __html: item?.description }}
                    />
                    <td>{item?.weight}</td>
                    <td>
                      {permissions?.includes("delete_department") && (
                        <button
                          className="inbox__email-btn"
                          type="button"
                          aria-label="delete"
                          onClick={() => deleteHandler(item?.id)}
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      )}
                      {permissions?.includes("update_department") && (
                        <button
                          className="inbox__email-btn"
                          type="button"
                          aria-label="edit"
                          onClick={() =>
                            history.push({
                              pathname: "/department/kpi-create",
                              state: { dept: deptID, id: item?.id },
                            })
                          }
                        >
                          <EditIcon fontSize="small" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={12}
                    className="text-center text-danger font-weight-bold"
                  >
                    KPI not found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {kpiData?.getAllKpiByDepartmentId?.data?.length > 0 ? (
            <Pagination
              className="mt-2"
              count={kpiData.getAllKpiByDepartmentId?.paginatorInfo.lastPage}
              page={kpiData.getAllKpiByDepartmentId?.paginatorInfo?.currentPage}
              onChange={handleChangeKpi}
            />
          ) : null}
        </>
      )} */}

      <CreateEmployeeKpiModal
        isOpen={kpiModalOpen}
        toggle={() => setKpiModalOpen(false)}
        employeeId={selectedEmployeeId}
        deptId={selectedDeptId}
      />
    </CardBody>
  );
};

export default DeptMemberTable;
